import classNames from 'classnames';
import { useContext } from 'react';

import TableContext from '../table/table-context';

export interface TableHeadIconCellProps {
  className?: string;
  size?: 'small' | 'medium' | 'xs'; // will also be passed from `Table` component via `TableContext`
  align?: 'inherit' | 'left' | 'right' | 'center' | 'justify';
}

export function TableHeadIconCell({
  className,
  children,
  size: sizeProp,
  align = 'inherit',
}: React.PropsWithChildren<TableHeadIconCellProps>) {
  const table = useContext(TableContext);
  const { size }: TableHeadIconCellProps = {
    size: sizeProp || table?.size || 'medium',
  };
  return (
    <th
      className={classNames(
        size === 'medium' && ['first:pl-3 first:pr-0', 'last:pl-0 last:pr-3', 'py-3', 'text-sm'],
        size === 'small' && ['first:pl-1 first:pr-2', 'last:pl-2 last:pr-1', 'py-2', 'text-xs'],
        size === 'xs' && ['first:pl-1 first:pr-2', 'last:pl-2 last:pr-1', 'py-2', 'text-xs'],
        align === 'inherit' && '[text-align:inherit]',
        align === 'left' && 'text-left',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        align === 'justify' && 'text-justify',
        'uppercase whitespace-nowrap text-gray-400 dark:text-gray-400 font-medium text-left',
        className
      )}
    >
      {children}
    </th>
  );
}

export default TableHeadIconCell;
